import * as React from 'react';

const Close2 = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={20} height={20} rx={10} fill="#D5EBF2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M5.19102 5.19108C5.44571 4.93639 5.85864 4.93639 6.11333 5.19108L10 9.07775L13.8867 5.19108C14.1414 4.93639 14.5543 4.93639 14.809 5.19108C15.0637 5.44577 15.0637 5.8587 14.809 6.11339L10.9223 10.0001L14.809 13.8867C15.0637 14.1414 15.0637 14.5544 14.809 14.809C14.5543 15.0637 14.1414 15.0637 13.8867 14.809L10 10.9224L6.11333 14.809C5.85864 15.0637 5.44571 15.0637 5.19102 14.809C4.93633 14.5544 4.93633 14.1414 5.19102 13.8867L9.07769 10.0001L5.19102 6.11339C4.93633 5.8587 4.93633 5.44577 5.19102 5.19108Z"
      fill="#2D8AA7"
    />
  </svg>
);
export default Close2;
